import * as React from "react";
// Components
import { MessageBar, MessageBarBody, MessageBarActions, Button, mergeClasses } from "@fluentui/react-components";
// Controls
import { SecureLink } from "../secureLink/SecureLink";
import { Dismiss } from "../icons";
// Constants
import { LearnMoreLinks } from "@ms/uno-constants/lib/local/AppConstants";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { useWelcomeBannerStyles } from "./WelcomeBanner.styles";
/**
 * Banner positioning options
 */ export var BannerPositioning = /*#__PURE__*/ function(BannerPositioning) {
    /** Default positioning - pushes content down */ BannerPositioning["Default"] = "default";
    /** Overlay positioning - floats over content */ BannerPositioning["Overlay"] = "overlay";
    return BannerPositioning;
}({});
/**
 * Welcome banner for the converged app
 */ export const WelcomeBanner = ({ onDismiss, positioning = "default" })=>{
    const shouldUseOverlay = positioning === "overlay";
    const styles = useWelcomeBannerStyles();
    const rootClassName = mergeClasses(styles.root, shouldUseOverlay && styles.tabViewOverlay);
    return /*#__PURE__*/ React.createElement(MessageBar, {
        className: rootClassName,
        icon: null
    }, /*#__PURE__*/ React.createElement(MessageBarBody, {
        className: styles.content
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.text
    }, Strings.WelcomeBanner_WelcomeText, " ", /*#__PURE__*/ React.createElement(SecureLink, {
        href: LearnMoreLinks.welcomeBanner,
        className: styles.link
    }, Strings.WelcomeBanner_LearnMoreText))), onDismiss && /*#__PURE__*/ React.createElement(MessageBarActions, null, /*#__PURE__*/ React.createElement(Button, {
        appearance: "transparent",
        icon: /*#__PURE__*/ React.createElement(Dismiss, null),
        onClick: onDismiss,
        "aria-label": Strings.WelcomeBanner_CloseAriaLabel,
        className: styles.dismissButton
    })));
};
